export enum LectureCategory {
    ARTAUDIO = "Art/Audio",
    BUSINESS = "Business",
    DESIGN = "Design",
    TECHNICAL = "Technical",
    INDUSTRYSUPPORT = "Industry Support",
    OTHER = "Other"
}
